import React, { useState } from 'react';
import { Button, Chip } from '@lumx/react';
import { NodeType, OUNode } from '../../types';
import { Icon } from '../shared/icons';
import ParentPicker from '../shared/ParentPicker';

interface Props {
  parentId: string | null;
  nodes: OUNode[];
  onSave: (name: string, type: NodeType, parentId: string | null) => void;
  onCancel: () => void;
}

const AddUnitForm: React.FC<Props> = ({ parentId, nodes, onSave, onCancel }) => {
  const [name, setName] = useState('');
  const [type, setType] = useState<NodeType>('OrganizationalUnit');
  const [pid, setPid] = useState<string | null>(parentId);

  const handleSave = () => { if (name.trim()) onSave(name.trim(), type, pid); };

  return (
    <div style={{
      gridColumn: '1 / -1',
      background: 'var(--color-surface-subtle)',
      borderTop: '1px solid var(--color-border)',
      padding: '8px 16px',
      display: 'flex',
      alignItems: 'center',
      gap: 16,
      flexWrap: 'wrap',
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        <span className="form-label">Name</span>
        <input
          className="form-input"
          autoFocus
          placeholder="e.g. North America"
          value={name}
          onChange={e => setName(e.target.value)}
          onKeyDown={e => { if (e.key === 'Enter') handleSave(); if (e.key === 'Escape') onCancel(); }}
          style={{ width: 200 }}
        />
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        <span className="form-label">Type</span>
        <div className="form-type-row">
          <Chip isClickable isSelected={type === 'OrganizationalUnit'} before={Icon.building} size="s" onClick={() => setType('OrganizationalUnit')}>
            Org unit
          </Chip>
          <Chip isClickable isSelected={type === 'Location'} before={Icon.location} size="s" onClick={() => setType('Location')}>
            Location
          </Chip>
        </div>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        <span className="form-label">Parent unit</span>
        <ParentPicker value={pid} nodes={nodes} onChange={setPid} />
      </div>
      <div className="form-actions" style={{ marginLeft: 'auto' }}>
        <Button emphasis="medium" size="s" onClick={onCancel}>Cancel</Button>
        <Button emphasis="high" size="s" onClick={handleSave} isDisabled={!name.trim()}>Add unit</Button>
      </div>
    </div>
  );
};

export default AddUnitForm;
